import React, { Component } from 'react';
import moment from 'moment';
import Last30 from './stats/Last30.js';
import DailyStats from './stats/DailyStats.js';
import AdDeliveryConfig from './config/AdDeliveryConfig.js';
import { Modal, Button } from 'react-bootstrap';

import axios from 'axios';
import settings from './../config/settings.json';
import { getAllUrlParams } from './../helper/util.js';

class TariffModal extends Component {
  constructor(props) {
    super(props);
  }
  render() {

    function cancelSubscription(event) {
      var apikey = getAllUrlParams().apikey;
      var url = settings.relevanz.apiBase + '/cancelSubscription?apikey=' + apikey;
  
      axios.post(url)
        .then((response) => {
          if(response.data === 'OK') {
            alert('Ihr Account wurde gekündigt!');
            window.location.reload();
          } else {
            alert('internal error please contact customer support (support@releva.nz)');
          }
        }).catch((error) => {
          alert('error please contact customer support (support@releva.nz)');
        });
  
      event.preventDefault();
    }

    return(
      <Modal {...this.props}>
      <Modal.Header closeButton>
        <Modal.Title>Kündigung deines Tarifs</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Du willst deinen Vertrag wirklich kündigen?</h4>

        <p>
          Schade, manchmal dauert es etwas bis die Erfolge zu sehen sind und unser System deine Kampagne automatisiert zum Erfolg geführt hat.
        </p>
        <p>
          Natürlich kannst du dennoch hier einfach kündigen. 
        </p>
        <p>
          {this.props.customerInfo.test_customer === true ?
          <span>Bitte beachte das mit dem Klick auf den Button dein Account sofort gesperrt wird.</span>
          :
          <span>Mit einem Klick auf Kündigen endet dein Abonnement automatisch am {this.props.customerInfo.end_date}.</span>
          }
        </p>
        <p><button className="btn blue" onClick={cancelSubscription}>Kündigen</button></p>
        
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={this.props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
    )
  }
}

class TariffInfo extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      smShow: false
    };
  }
  render() {
    let smClose = () => this.setState({ smShow: false });
    return(
      <div className="portlet light bordered">
        <div>
        <TariffModal customerInfo={this.props.customerInfo} show={this.state.smShow} onHide={smClose}></TariffModal>
        </div>
        <div className="portlet-title">
          <div className="caption">
            <i className="icon-share font-dark">
            </i>
            <span className="caption-subject font-dark bold uppercase">
              Tarif Informationen
            </span>
          </div>
        </div>
        <div className="portlet-body">
          <div className="margin-top-10 margin-bottom-10 clearfix">
            <table className="table table-bordered table-striped">
              <tbody>
                <tr>
                  <td>
                    Kunden ID
                  </td>
                  <td>
                    {this.props.customerInfo.user_id}
                  </td>
                </tr>
                <tr>
                  <td>
                    Aktueller Tarif
                  </td>
                  <td>
                    {this.props.customerInfo.tariff_name}
                  </td>
                </tr>
                <tr>
                  <td>
                    Monatlicher Preis
                  </td>
                  <td>
                  {this.props.customerInfo.pricing} Euro
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    {this.props.customerInfo.cancelled_subscription === 0 
                      ? <span>Automatische Verlängerung am: {this.props.customerInfo.end_date}</span> 
                      : <span>Dein Vertrag endet am {this.props.customerInfo.end_date}</span>}
                  </td>
                </tr>
                {this.props.customerInfo.cancelled_subscription === 0 
                  ? <tr>
                  <td colSpan={2}>
                    <span>Du bist unzufrieden? Melde dich bei uns! Keine Chance? Dann kannst du hier kündigen. <button className="btn btn-primary btn-sm"  onClick={() => this.setState({ smShow: true })}>Kündigen</button></span> 
                  </td>
                </tr> : <div></div> }               
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

class TestCustomer extends Component {
  render() {
    return(
      <div className="portlet light bordered">
        <div className="portlet-title">
          <div className="caption">
            <i className="icon-magic-wand font-dark">
            </i>
            <span className="caption-subject font-dark bold uppercase">
              Na wie läuft dein Test?
            </span>
          </div>
        </div>
        <div className="portlet-body">
          <div className="margin-top-10 margin-bottom-10 clearfix">
            Bis die ersten Resultate zu sehen sind, vergeht immer ein wenig Zeit, aber dann gehts rund!<br />
            Jetzt schon überzeugt oder drückt irgendwo der Schuh? Dann melde dich doch kurz <a href="mailto:hello@releva.nz">support@releva.nz</a>.<br />
            Läuft schon ganz rund? Dann erhöhe deinen Werbedruck und werde Kunde!
          </div>
        </div>
      </div>
    )
  }
}

export class Content extends Component {
  constructor(props) {
    props.customerInfo.end_date = moment(props.customerInfo.end_date).format('DD.MM.YYYY');
    super(props);
  }
  render() {
    return (
      <div>
       {this.props.customerInfo.test_customer && <TestCustomer customer={this.props.customerInfo}/>
       }
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h1>Statistiken der letzten 30 Tage</h1>
          </div>
        </div>
        <a name="stats"></a>

        <Last30 stats={this.props.stats.last30}/>

        <DailyStats></DailyStats>

        <div className="row">
          <div className="col-md-6">
            <a name="tariff"></a>
            <TariffInfo customerInfo={this.props.customerInfo}/>
          </div>
          <div className="col-md-6">
            <a name="config"></a>
            <AdDeliveryConfig budget={this.props.customerInfo.budget}/>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Content.js